<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/SocialMediaInfo">ขอเปลี่ยนแปลงข้อมูล Soial Media</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            แก้ไข TikTok
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <!-- Mobile -->
            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
                    style="font-family: DB Heavent; color: #0057a8">
                    TikTok
                </div>
            </div>
            <!-- Mobile -->
            <div class="col">
                <div class="title d-none d-lg-block border-bottom" style="font-family: DB Heavent; color: #0057a8">
                    TikTok
                </div>
                <div class="pb-3 pb-lg-3">
                    <div class="mt-4 mt-lg-2">
                        <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
                            ข้อมูลเดิม
                        </div>
                    </div>
                    <div class="d-lg-flex align-items-center" style="font-family: monospace;">
                        <div class="blue-1 fs-6 mt-1 mt-lg-1">{{ Data.OldTikTokName }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="form-group fs-5 font-family">
                            <label class="field a-field page__field">
                                เปลี่ยนเป็น<span class="required">*</span> :
                                <input v-model.trim="Data.NewTikTokName" type="text"
                                    class="field__input a-field__input fs-6" style="font-family: monospace;"
                                    maxlength="30" @input="ValidateTikTokName"
                                    :class="{ 'invalid': !isNewTikTokNameValid && Data.NewTikTokName !== '' }" />
                            </label>
                            <span v-if="(!isNewTikTokNameValid && Data.NewTikTokName !== '')
                                || (Data.OldTikTokName !== null
                                    && Data.NewTikTokName !== null
                                    && Data.NewTikTokName.toLowerCase() === Data.OldTikTokName.toLowerCase())"
                                class="error-message">
                                ชื่อ TikTok ไม่ถูกต้อง
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row mb-3 mt-2">
                    <div class="col-6 col-lg-6">
                        <button type="button" class="btn btn-light btn-cancel font-family d-inline-block"
                            @click="ChechCreateJob('/SocialMediaInfo')">
                            ย้อนกลับ
                        </button>
                    </div>
                    <div class="col-6 col-lg-6 text-right">
                        <button type="button" class="btn btn-continue font-family d-inline-block" @click="EnterNext()">
                            ดำเนินการต่อ
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>
<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';
import { ref } from 'vue';

export default {
    name: "EditTikTok",
    components: {
        Menu,
        LoadingBs5,
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();
        this.BindingData();

        this.Data.OldTikTokName = this.Data.OldTikTokName == null ? '' : this.Data.OldTikTokName;
        this.Data.NewTikTokName = this.Data.NewTikTokName == null ? '' : this.Data.NewTikTokName;
    },
    data() {
        return {
            Loading: true,
            IsEditTikTok: false,
            Data: {
                OldTikTokName: '',
                NewTikTokName: '',
            },
            isNewTikTokNameValid: ref(true),
        }
    },
    methods: {
        EnterNext() {
            this.ValidateTikTokName();

            if ((this.Data.NewTikTokName.trim() !== '' && !this.isNewTikTokNameValid)
                || (this.Data.NewTikTokName.toLowerCase() === this.Data.OldTikTokName.toLowerCase())) {
                Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">ชื่อ TikTok ไม่ถูกต้อง</lable>',
                });
            }
            else if (this.Data.NewTikTokName.trim() == '') {
                Swal.fire({
                    icon: 'error',
                    html: '<lable class="fs-4 fw-normal font-family">กรุณาระบุ TikTok</lable>',
                });
            } else {
                this.$store.state.SocialMediaInfo.TikTok.IsEditTikTok = true;
                this.$store.state.SocialMediaInfo.TikTok.Data.NewTikTokName = this.Data.NewTikTokName;

                this.$router.push('/SocialMediaInfo');
            }
        },
        ValidateTikTokName() {
            const namePattern = /^[\p{L}\p{N}@._-]{1,30}$/u;///^[a-zA-Z0-9_.]{1,30}$/;
            this.isNewTikTokNameValid = namePattern.test(this.Data.NewTikTokName);
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
        BindingData() {
            this.IsEditTikTok = this.$store.state.SocialMediaInfo.TikTok.IsEditTikTok;
            this.Data.OldTikTokName = this.$store.state.SocialMediaInfo.TikTok.Data.OldTikTokName;
            this.Data.NewTikTokName = this.$store.state.SocialMediaInfo.TikTok.Data.NewTikTokName;
        },
        ChechCreateJob(to) {
            this.Authorization();
            this.$router.push(to);
        },
        ClearData() {
            this.$store.state.SocialMediaInfo.TikTok.IsEditTikTok = false;
            this.$store.state.SocialMediaInfo.TikTok.Data.NewTikTokName = '';
        },
    },
};
</script>

<style scoped>
.font-family-bla {
    font-family: "DB Heavent";
}

.invalid {
    border-color: red;
}

.error-message {
    color: red;
}
</style>